import React from 'react';
import loadable from '@loadable/component';

import { convertToBgImage } from 'gbimage-bridge';
import BackgroundImage from 'gatsby-background-image';

const Wrapper = loadable(() => import('./Wrapper'), {
  ssr: false
});
const BlockNumbers = loadable(() => import('./BlockNumbers'));
const Testimonials = loadable(() => import('./Testimonials'));
const PhotoGrid = loadable(() => import('./PhotoGrid'));
const Article = loadable(() => import('./Article'));
const Articles = loadable(() => import('./Articles'));
const SlidingCards = loadable(() => import('./SlidingCards'));
const TypologyCards = loadable(() => import('./TypologyCards'));
const RegularSection = loadable(() => import('./RegularSection'));
const BlockLogos = loadable(() => import('./BlockLogos'));
const VideoCards = loadable(() => import('./VideoCards'));
const FullWidthSection = loadable(() => import('./FullWidthSection'));
const FilteredSections = loadable(() => import('./FilteredSections'));
const JobBoard = loadable(() => import('./JobBoard'));
const Terms = loadable(() => import('./Terms'));
const TextSections = loadable(() => import('./TextSections'));
const FullVideoSection = loadable(() => import('./FullVideoSection'));
const FaqSection = loadable(() => import('./FaqSection'));
const Geolocalisation = loadable(() => import('./Geolocalisation'));
const SectionTestimonial = loadable(() => import('./SectionTestimonial'));
const Anchor = loadable(() => import('./Anchor'));
const Children = loadable(() => import('./Children'));

const components = {
  'sliding-cards': SlidingCards,
  testimonials: Testimonials,
  numbers: BlockNumbers,
  'typology-cards': TypologyCards,
  regular: RegularSection,
  logos: BlockLogos,
  'video-cards': VideoCards,
  'full-width-section': FullWidthSection,
  'filtered-sections': FilteredSections,
  'photo-grid': PhotoGrid,
  'job-board': JobBoard,
  articles: Articles,
  terms: Terms,
  article: Article,
  'text-sections': TextSections,
  'full-video-section': FullVideoSection,
  faq: FaqSection,
  geolocalisation: Geolocalisation,
  testimonial: SectionTestimonial,
  children: Children
};

export default function Section({ section = {}, articles = [], children }) {
  const {
    backgroundColor,
    isFullWidth,
    isDarkMode,
    version,
    illustration,
    hasAdditionalSections,
    isAdditionalSection,
    references,
    additionalClassNames
  } = section;
  const file = illustration?.file;
  const isBackgroundImage = illustration?.isBackgroundImage;

  const bgImage = convertToBgImage(file?.gatsbyImageData);
  const style = `section ${isDarkMode ? '--dark' : ''} ${
    backgroundColor ? '--background-color' : ''
  } ${isBackgroundImage ? '--background-image' : ''} ${
    !isFullWidth ? '--rounded' : ''
  }${additionalClassNames || ''}`;

  const SectionComponent = components[version];
  return (
    <>
      {SectionComponent && (
        <Wrapper
          condition={backgroundColor}
          wrapper={(children) => (
            <div className={`background-${backgroundColor}`}>{children}</div>
          )}
        >
          <Wrapper
            condition={!isFullWidth}
            wrapper={(children) => <div className="wrapper">{children}</div>}
          >
            <Wrapper
              condition={isBackgroundImage && bgImage}
              wrapper={(children) => (
                <BackgroundImage
                  style={{
                    borderRadius: '8px',
                    overflow: 'hidden'
                  }}
                  {...bgImage}
                >
                  {children}
                </BackgroundImage>
              )}
            >
              <section className={style}>
                <Wrapper
                  condition={
                    isFullWidth &&
                    !hasAdditionalSections &&
                    !isAdditionalSection
                  }
                  wrapper={(children) => (
                    <div className="wrapper">{children}</div>
                  )}
                >
                  <Anchor section={section} />
                  <SectionComponent
                    section={{ ...section, articles }}
                    children={children}
                  />
                </Wrapper>
              </section>
              {hasAdditionalSections && references && (
                <>
                  {references.map((ref) => (
                    <Section section={ref} key={ref.id} />
                  ))}
                </>
              )}
            </Wrapper>
          </Wrapper>
        </Wrapper>
      )}
    </>
  );
}
